<template lang="pug">
    .logo
</template>

<script>
export default {
  name: "Logo"
};
</script>

<style lang="scss" scoped>
.logo {
  width: 5.2em;
  height: 1.3em;
  background-image: url("../assets/images/logo.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
